import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";

interface HeadToHeadProps {
  matchHistory: Array<{ 
    userWon: boolean;
    opponents?: string[];
    teammate?: string;
  }>;
}

export function HeadToHead({ matchHistory }: HeadToHeadProps) {
  const headToHead = new Map<string, { wins: number; losses: number }>();

  matchHistory.forEach(match => {
    if (match.opponents && match.opponents.length > 0) {
      match.opponents.forEach(opponent => {
        const current = headToHead.get(opponent) || { wins: 0, losses: 0 };
        if (match.userWon) {
          current.wins++;
        } else {
          current.losses++;
        }
        headToHead.set(opponent, current);
      });
    }
  });

  const sorted = Array.from(headToHead.entries())
    .sort((a, b) => (b[1].wins - b[1].losses) - (a[1].wins - a[1].losses))
    .slice(0, 5);

  return (
    <Card className="p-4" data-testid="card-head-to-head">
      <p className="text-sm font-semibold mb-3">Record vs Oponentes Frecuentes</p>
      {sorted.length === 0 ? (
        <p className="text-sm text-muted-foreground">No hay suficientes partidos</p>
      ) : (
        <div className="space-y-2">
          {sorted.map(([opponent, record]) => (
            <div key={opponent} className="flex items-center justify-between gap-2">
              <span className="text-sm truncate flex-1">{opponent}</span>
              <div className="flex items-center gap-2">
                <Badge variant="outline" className="text-xs">
                  {record.wins}-{record.losses}
                </Badge>
                <span className="text-xs text-muted-foreground w-8 text-right">
                  {Math.round((record.wins / (record.wins + record.losses)) * 100)}%
                </span>
              </div>
            </div>
          ))}
        </div>
      )}
    </Card>
  );
}
